import type { EmbarcacaoContatosField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const CONTATOS_ID = "contatos";
export const CONTATOS_TITLE = "Contatos";
export const CONTATOS_TEST_ID = "embarcacao-contatos";
export const CONTATOS_LOADING_MESSAGE = "Carregando os Contatos da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const CONTATOS_EMPTY_STATE = {
  title: "Nenhuma informação de Contatos disponível",
  description:
    "Assim que houver contatos ou responsáveis de frota desta embarcação, eles aparecerão nesta seção.",
};

interface ContatosFieldDefinition extends DetailFieldDefinition<EmbarcacaoContatosField> {
  /** E-mail acionável: abre uma nova mensagem no cliente de e-mail (RN005). */
  readonly email?: boolean;
}

/** Os 10 campos, na ordem da HU; os e-mails da embarcação abrem uma nova mensagem (HU 2673). */
export const CONTATOS_FIELDS: ContatosFieldDefinition[] = [
  { key: "celularEmbarcacao", label: "Celular da Embarcação" },
  { key: "bridgeEmail", label: "Bridge E-mail", email: true },
  { key: "captainEmail", label: "Captain E-mail", email: true },
  { key: "engineEmail", label: "Engine E-mail", email: true },
  { key: "chiefEngEmail", label: "ChiefEng E-mail", email: true },
  { key: "gerenteFrota", label: "Gerente de Frota", startsRow: true },
  { key: "contatoGerenteFrota", label: "Contato Gerente de Frota" },
  { key: "coordenadorFrota", label: "Coordenador de Frota" },
  { key: "contatoCoordenadorFrota", label: "Contato Coordenador de Frota" },
  {
    key: "atualizacaoContato",
    label: "Data de Atualização Contatos",
    format: formatDetailDate,
    startsRow: true,
  },
];
